export default "__VITE_ASSET__Cbv_CZ9k__"